// extracted by mini-css-extract-plugin
module.exports = {"loaderDots":"LoaderDots-module__loaderDots___UDtYL","blink":"LoaderDots-module__blink___DPtLd"};